import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import NumberFormat from 'react-number-format';

//Para los select
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';


function NumberFormatCustom(props) 
{
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      decimalScale={2}
      fixedDecimalScale={true}
      onValueChange={values => {
        onChange({
          target: {
            id:"price",
            value: values.value,
          },
        });
      }}
      thousandSeparator
    />
  );
}

export default class  SubcontractCostInfo extends React.Component  {

  render()
  {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Cost Information
        </Typography>
        <Grid container spacing={24}>
            <Grid item  xs={12} sm={6}>
               <TextField
                  id="price"
                  label="Unit Price"
                  type="text"
                  value={this.props.costinfo.price || ''}
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                  }}
                  onChange={this.props.handleChange}
                  disabled={this.props.reviewActive}
                  error={this.props.errores.price}
                  helperText={this.props.errores.price}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                  <InputLabel htmlFor="period_type" style={{marginRight:'10px'}}>Type of cost</InputLabel>
                  <Select
                    required
                    fullWidth
                    id="period_type"
                    name="period_type"
                    value={this.props.costinfo.period_type}
                    onChange={this.props.handleChange}
                    disabled={this.props.reviewActive}
                    error={this.props.errores.period_type}
                    helperText={this.props.errores.period_type}
                  >
                    <MenuItem native="true" key={1} value={1} selected>
                      Start
                    </MenuItem>
                    <MenuItem native="true" key={2} value={2}>
                      End
                    </MenuItem>
                    <MenuItem native="true" key={3} value={3}>
                      Weighted
                    </MenuItem>
                  </Select>
              </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

SubcontractCostInfo.propTypes = {
  classes: PropTypes.object.isRequired,
};


// WEBPACK FOOTER //
// ./src/features/cost/SubcontractCostInfo.js